import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FaBars, 
  FaTimes, 
  FaHome, 
  FaMapMarkerAlt, 
  FaCar, 
  FaMoneyBillWave, 
  FaStar, 
  FaInfoCircle,
  FaPhone,
  FaRoute,
  FaCalculator
} from 'react-icons/fa';
import logoImage from '../data/images/bgremove.png';
import phoneIcon from '../data/images/phonenumIcon.png';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Navigation items
  const navItems = [
    { id: 'home', icon: FaHome, label: 'Home', section: 'top' },
    { id: 'booking', icon: FaCalculator, label: 'Book Now', section: 'booking-section' },
    { id: 'destinations', icon: FaMapMarkerAlt, label: 'Destinations', section: 'popular-destinations' },
    { id: 'local-trips', icon: FaRoute, label: 'Local Trips', section: 'local-trips' },
    { id: 'vehicles', icon: FaCar, label: 'Vehicles', section: 'vehicles-section' },
    { id: 'tariff', icon: FaMoneyBillWave, label: 'Tariff', section: 'tariff-section' },
    { id: 'testimonials', icon: FaStar, label: 'Testimonials', section: 'testimonials-section' },
    { id: 'why-choose', icon: FaInfoCircle, label: 'Why Choose Us', section: 'why-choose-section' },
    { id: 'contact', icon: FaPhone, label: 'Contact', section: 'footer' }
  ];

  // Scroll to section
  const scrollToSection = (sectionId) => {
    if (sectionId === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId) || 
                     document.querySelector(`.${sectionId}`);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo Section - Left */}
        <div className="logo-section">
          <img src={logoImage} alt="DropTaxiService" className="logo-image" />
        </div>
        
        {/* Center Section - Text and Contact */}
        <div className="center-section">
          <div className="logo-text">
            <h1>One Way Drop Taxi Service</h1>
            <p className="subtitle">Best One Way Cabs in Tamilnadu</p>
          </div>
          
          <div className="contact-item">
            <a href="tel:+917200085345" className="phone-link">
              <img src={phoneIcon} alt="Phone" className="phone-icon-image" />
              <span>7200085345</span>
            </a>
          </div>
        </div>
        
        {/* Navigation Menu Button - Right */}
        <button 
          className={`header-nav-toggle ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Dropdown Navigation Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <>
            <motion.div
              className="header-nav-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
            />
            
            <motion.nav
              className="header-nav-menu"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            >
              {navItems.map((item, index) => {
                const Icon = item.icon;
                return (
                  <motion.button
                    key={item.id}
                    className="header-nav-item"
                    onClick={() => scrollToSection(item.section)}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ x: 5, backgroundColor: '#fef3c7' }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Icon className="nav-item-icon" />
                    <span className="nav-item-label">{item.label}</span>
                  </motion.button>
                );
              })}
            </motion.nav>
          </>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;